var _rect, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFinalFiveGreen(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "none",
    height: 72,
    viewBox: "0 0 32 72",
    width: 32,
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    fill: "#43bf5e",
    height: 31,
    rx: 15.5,
    width: 32
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m15.7891 21.1875c-2.1563 0-3.6953-1.3437-3.8594-3.1797l-.0078-.0859h1.3828l.0078.0625c.1406 1.1172 1.1406 1.9687 2.4922 1.9687 1.5312 0 2.5937-1.0625 2.5937-2.5781v-.0156c-.0078-1.4844-1.0781-2.5469-2.5703-2.5469-.7656 0-1.4219.2266-1.9219.6797-.2031.1875-.3828.4062-.5312.664h-1.2422l.5781-6.42964h6.4532v1.25004h-5.2969l-.3828 3.789h.0312c.5313-.7578 1.4688-1.164 2.5625-1.164 2.1641 0 3.7266 1.5703 3.7266 3.7343v.0157c-.0078 2.2578-1.6719 3.8359-4.0156 3.8359z",
    fill: "#fff"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFinalFiveGreen);
export default __webpack_public_path__ + "static/media/finalFiveGreen.e4e34f3e849b38a0fd7d5c3d99098f47.svg";
export { ForwardRef as ReactComponent };